const getDateSelectorItems = () => {
  return [
    {
      id: 1,
      type: 'relative',
      name: 'Less than',
      value: 'lt',
      unit: 'hour'
    },
    {
      id: 3,
      type: 'relative',
      name: 'More than',
      value: 'gt',
      unit: 'hour'
    },
    {
      id: 4,
      type: 'absolute',
      name: 'Before',
      value: 'before'
    },
    {
      id: 5,
      type: 'absolute',
      name: 'On',
      value: 'on'
    },
    {
      id: 6,
      type: 'absolute',
      name: 'After',
      value: 'after'
    }
  ]
}
export default getDateSelectorItems
